<template>
    <div class="configurator-select-combobox mb-4" v-bind:id="groupId">
        <accordion :show="false">
            <div slot="header">{{ title }}</div>
            <div>
                <div class="more_options_legend">
                    <ul class="d-flex flex-row">
                        <li class="mr-auto"></li>
                        <li class="mr-4"><i class="fas fa-cube mr-2"></i> {{ $t('personalize.moreOptionsLegendText1') }}</li>
                        <li><i class="fas fa-thumbs-up mr-2"></i> {{ $t('personalize.moreOptionsLegendText2') }}</li>
                    </ul>
                </div>
                <div v-for="item in groupData" class="row">
                    <div v-for="(itemData, indexData) in item" :category="itemData.Category" class="col-md-6 col-xl-4 mb-4">
                        <div v-for="itemSelect in itemData.Value" v-if="!itemData.NotSelected" :class="'select-combobox-' + group" class="select-combobox-container">
                            <div v-for="itemSelectValue in itemSelect" v-if="itemSelectValue.Selected" :class="{ 'space-bottom' : itemSelectValue.InfoImage}">
                                <div class="select-combobox-title">{{ itemData.Description }}</div>

                                <div :id="'select_combobox_' + groupId + '_' + indexData"></div>
                                <div class="select-combobox-subtitle">{{ itemSelectValue.Description }}</div>
                                <div v-if="itemSelectValue.InfoText && itemSelectValue.InfoText.length > 200" class="select-combobox-text read-more-text" v-html="itemSelectValue.InfoText">{{ itemSelectValue.InfoText }}</div>
                                <div v-if="itemSelectValue.InfoText && itemSelectValue.InfoText.length < 200" class="select-combobox-text" v-html="itemSelectValue.InfoText">{{ itemSelectValue.InfoText }}</div>

                                <div class="select-combobox-action-container">
                                    <a href="#" :ref="'readMore_' + itemData.Category" class="select-combobox-read-more" v-if="itemSelectValue.InfoText && itemSelectValue.InfoText.length > 200" v-on:click="toggleRead($event, 'more', itemData.Category)">Mehr anzeigen <i class="fas fa-angle-down"></i></a>
                                    <a href="#" :ref="'readLess_' + itemData.Category" class="select-combobox-read-less" v-if="itemSelectValue.InfoText" v-on:click="toggleRead($event, 'less', itemData.Category)">Weniger anzeigen <i class="fas fa-angle-up"></i></a>
                                </div>

                                <div class="select-combobox-image" v-if="itemSelectValue.InfoImage">
                                    &nbsp;
                                    <v-lazy-image :src="itemSelectValue.InfoImage" />
                                </div>
                            </div>
                        </div>

                        <div v-else-if="itemData.NotSelected" :class="'select-combobox-' + group" class="select-combobox-container">
                            <div class="select-combobox-title">{{ itemData.Description }}</div>

                            <div :id="'select_combobox_' + groupId + '_' + indexData"></div>
                        </div>
                    </div>
                </div>
            </div>
        </accordion>
    </div>
</template>

<script>
    import VLazyImage from "v-lazy-image";

    export default {
        name: 'SelectCombobox',
        props: {
            title: String,
            options: Array,
            group: String
        },
        data() {
            return {
                groupData: [],
                loading: true,
                selectData: [],
                category: '',
                showReadMore: false
            }
        },
        components: {
            VLazyImage
        },
        computed: {
          groupId() {
              return this.group.replace(/ /gi, "_")
          }
        },
        mounted() {

        },
        methods: {
            toggleRead: function(event, state, category) {
                event.preventDefault();

                if(state === "more") {
                    let readMore = this.$refs['readMore_' + category];
                    $(readMore).hide();
                    $(readMore).parent().siblings('.select-combobox-text').css( { 'height':'auto', 'max-height':'300px', 'overflow-y': 'auto' } );
                    $(readMore).siblings('.select-combobox-read-less').show();
                } else if(state === "less") {
                    let readLess = this.$refs['readLess_' + category];
                    $(readLess).hide();
                    $(readLess).parent().siblings('.select-combobox-text').css( { 'height':'85px', 'margin-bottom': '0', 'overflow-y': 'hidden' } );
                    $(readLess).siblings('.select-combobox-read-more').show();
                }
            },
            getGroupData: function() {
                let params = new URLSearchParams();
                params.append('apikey', this.$apikey);
                params.append('apipassword', this.$apipassword);
                params.append('ConfigurationID', this.$parent.$parent.ConfigurationID);
                params.append('CustomerID', this.$parent.$parent.customerID);

                let values = [];
                let app = this;
                let parent = app.$parent;

                parent.$parent.loading = true;

                app.getGroupDataPost(app,parent,params,values);
            },
            getGroupDataPost(app,parent,params,values) {
                this.$http.post(this.$apiurl + '/api/GetGroupData/' + app.group, params)
                    .then(response => {
                        app.groupData.push(response.data['ReturnData']);

                        $.each(response.data['ReturnData'], function(indexData, valueData) {
                            $.each(valueData.Value, function(indexSelect, valueSelect) {
                                $.each(valueSelect, function(indexItem, valueItem) {
                                    values = valueSelect;

                                    valueItem['Group'] = app.group+' - '+valueData['Category'];
                                });
                            });

                            if(values.length !== 0) app.buildSelect(indexData, values);
                        });

                        let scrollToContainer = '#'+app.group.replace(/ /gi, "_");
                        VueScrollTo.scrollTo(scrollToContainer);
                    })
                    .catch(error => {
                        // TOUT-1622: Retry begrenzt (zuvor unbegrenzt und ohne Verzoegerung)
                        const versuch = (app.__ggdVersuch || 0) + 1;
                        app.__ggdVersuch = versuch;
                        if (versuch >= 3) {
                            console.error('GetGroupData: nach 3 Versuchen abgebrochen.', error);
                            app.__ggdVersuch = 0;
                            return;
                        }
                        setTimeout(function () {
                            app.getGroupDataPost(app,parent,params,values);
                        }, 500 * Math.pow(2, versuch - 1));
                    })
                    .finally(() => parent.$parent.loading = false);
            },
            onSelected: function(data, characteristic) {
                let app = this;
                let parent = app.$parent;
                let values = [];

                let params = new URLSearchParams();
                params.append('apikey', this.$apikey);
                params.append('apipassword', this.$apipassword);
                params.append('ConfigurationID', parent.$parent.ConfigurationID);
                params.append('CustomerID', parent.$parent.customerID);
                params.append('Characteristic', characteristic);
                params.append('Value', data['selectedData']['Name']);

                let selectCombobox = $('.select-combobox-' + app.group);
                selectCombobox.css('opacity', '0.5');

                parent.popupError = false;
                parent.$parent.loading = true;

                app.onSelectedPost(app,parent,params,values,selectCombobox);
            },
            onSelectedPost(app,parent,params,values,selectCombobox) {
                this.$http.post(this.$apiurl + '/api/SetValue', params)
                    .then(response => {
                        app.groupData = [];
                        app.groupData.push(response.data['ReturnData']);

                        if(response.data['TransferData']['Message'] && !response.data['TransferData']['ConfigKey']) {
                            parent.$parent.popupInfoText = response.data['TransferData']['Message'];
                            parent.$parent.popupInfo = true;
                            setTimeout(function() {
                                parent.$parent.popupInfo = false;
                            }, response.data['TransferData']['MessageTimeout']);
                        }

                        $.each(response.data['ReturnData'], function(indexData, valueData) {
                            $.each(valueData.Value, function(indexSelect, valueSelect) {
                                $.each(valueSelect, function(indexItem, valueItem) {
                                    values = valueSelect;

                                    valueItem['Group'] = app.group+' - '+valueData['Category'];
                                });
                            });

                            $("#select_combobox_" + app.group.replace(/ /g, '_') + "_" + indexData).ddslick('destroy');
                            if(values.length !== 0) app.buildSelect(indexData, values);
                        });

                        if(response.data['TransferData']['ReloadGroup']) {
                            $.each(response.data['TransferData']['ReloadGroup'], function(indexGroup, valueGroup) {
                                let ref = parent.$refs['selectCombobox_' + valueGroup];
                                ref[0].groupData = [];
                                ref[0].getGroupData();
                            });
                        }


                        if(response.data['TransferData']['Price'])
                            parent.$parent.price = response.data['TransferData']['Price'].toFixed(2).replace('.', ',') + ' ' + parent.$parent.priceSymbol;

                        if(response.data['TransferData']['ConfigurationID'])
                            parent.$parent.ConfigurationID = response.data['TransferData']['ConfigurationID'];

                        parent.$parent.step = 2;
                        selectCombobox.css('opacity', '1');
                        app.$parent.$parent.loading = false;
                    })
                    .catch(error => {
                        app.onSelectedPost(app,parent,params,values,selectCombobox);
                    })
            },
            buildSelect: function (id, data) {
                let selectedKey = null;
                let selectText = this.$i18n.t('personalize.selectColor');
                let app = this;
                let parent = app.$parent;
                let counter = 0;

                for(let i=0; i < data.length; i++)
                {
                    if(data[i]['Selected'] === true)
                    {
                        selectedKey = i;
                    }
                    data[i]['PriceSymbol'] = parent.$parent.priceSymbol;
                }

                let interVal = setInterval(function(){
                    let selectComboboxGroup = $("#select_combobox_" + app.groupId + "_" + id);

                    if(selectComboboxGroup.length !== 0 || counter === 1000)
                    {
                        clearInterval(interVal);
                        selectComboboxGroup.ddslick({
                            data: data,
                            defaultSelectedIndex: selectedKey,
                            selectText: selectText,
                            background: '#ffffff',
                            width: '100%',
                            onSelected: function(data){
                                app.onSelected(data, app.groupData[0][id]['Category']);
                            }
                        });
                    }
                    else {
                        counter++;
                    }
                })
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .configurator-select-combobox .more_options_legend {
        margin-top: 20px;
    }
    .configurator-select-combobox .more_options_legend ul {
        list-style: none;
        padding-left: 0;
        font-size: 13px;
        font-weight: 500;
    }
    .configurator-select-combobox .more_options_legend ul li i.fa-cube {
        height: 32px;
        width: 32px;
        text-align: center;
        vertical-align: middle;
        border-radius: 100%;
        background-color: #d6e5eb;
        color: #0f7398;
        padding-top: 9px;
    }
    .configurator-select-combobox .more_options_legend ul li i.fa-thumbs-up {
        height: 32px;
        width: 32px;
        text-align: center;
        vertical-align: middle;
        border-radius: 100%;
        background-color: #f7e5d5;
        color: #ec7205;
        padding-top: 9px;
    }
    .select-combobox-container {
        background: #ffffff;
        position: relative;
        border: 1px solid #afb0af;
        padding: 30px;
        height: 100%;
    }
    .select-combobox-container .space-bottom {
        padding-bottom: 195px !important;
    }
    .select-combobox-container .select-combobox-title {
        color: #ec7205;
        font-weight: bold;
        text-transform: uppercase;
        font-size: 15px;
        margin-bottom: 10px;
    }
    .select-combobox-container .select-combobox-subtitle {
        margin-top: 20px;
        margin-bottom: 5px;
        font-size: 15px;
        font-weight: bold;
        text-transform: uppercase;
    }
    .select-combobox-container .select-combobox-text {
        font-size: 13px;
        line-height: 1.6;
        font-weight: 500;
        background: #ffffff;
        overflow: hidden;
        position: relative;
        z-index: 1;
        -webkit-transition: all 0.3s ease;
        -moz-transition: all 0.3s ease;
        -o-transition: all 0.3s ease;
        -ms-transition: all 0.3s ease;
        transition: all 0.3s ease ;
    }
    .select-combobox-container .select-combobox-text >>> p {
        font-size: 13px;
        line-height: 1.6;
        font-weight: 500;
        background: #ffffff;
        overflow: hidden;
        position: relative;
        z-index: 1;
        -webkit-transition: all 0.3s ease;
        -moz-transition: all 0.3s ease;
        -o-transition: all 0.3s ease;
        -ms-transition: all 0.3s ease;
        transition: all 0.3s ease ;
    }
    .select-combobox-container .select-combobox-text.read-more-text {
        height: 85px;
    }
    .select-combobox-container .select-combobox-action-container {
        text-align: center;
        margin-top: 25px;
        margin-bottom: 15px;
    }
    .select-combobox-container .select-combobox-read-less {
        display: none;
        z-index: 1;
        font-family: Roboto Slab;
        font-size: 11px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.64;
        letter-spacing: 0.46px;
        text-transform: uppercase;
        color: #131313;
    }
    .select-combobox-container .select-combobox-read-less i {
        font-size: 16px;
        margin-left: 5px;
    }
    .select-combobox-container .select-combobox-read-more {
        font-family: Roboto Slab;
        font-size: 11px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.64;
        letter-spacing: 0.46px;
        text-transform: uppercase;
        color: #131313;
    }
    .select-combobox-container .select-combobox-read-more i {
        font-size: 16px;
        margin-left: 5px;
    }
    .select-combobox-container .select-combobox-image {
        position: absolute;
        z-index: 0;
        bottom: 1.5rem;
        left: 0;
        padding-left: 1.5rem;
        padding-right: 1.5rem;
        width: 100%;
    }
    .select-combobox-container .select-combobox-image img {
        width: 100%;
    }
    .v-lazy-image {
        opacity: 0;
        transition: opacity 2s;
    }
    .v-lazy-image-loaded {
        opacity: 1;
    }
</style>